import { IRowNode, RowEvent } from '@ag-grid-community/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'any' })
export class DatacenterSelectionService {
	deselectedNodes: IRowNode<unknown>[] = [];
	selectedNodes: IRowNode<unknown>[] = [];
	selectedCount = 0;
	isAllSelected = false;

	findDeselectedNode(id: string) {
		return this.deselectedNodes.find(deselectedItem => deselectedItem.id === id);
	}

	onRowSelected(event: RowEvent<'rowSelected'>, count?: number) {
		if (this.isAllSelected) {
			if (!event.node.isSelected()) {
				this.deselectedNodes.push(event.node);
			} else {
				this.deselectedNodes = this.deselectedNodes.filter(rowNode =>
					rowNode.id !== event.node.id);
			}
			if (count) {
				this.selectedCount = count - this.deselectedNodes.length;
			}
		} else {
			if (event.node.isSelected()) {
				this.selectedNodes.push(event.node);
			} else {
				this.selectedNodes = this.selectedNodes.filter(rowNode =>
					rowNode.id !== event.node.id);
			}
			this.selectedCount = this.selectedNodes.length;
		}
	}

	refreshCounterAfterFilter(count?: number) {
		this.selectedCount = count && this.isAllSelected
			? count - this.deselectedNodes.length
			: this.selectedNodes.length;
	}
}
